
import React from 'react';
import '../App.css';
import MethodToggle from './MethodToggle';

const Showcase = () => {
    return (
        <div style={{ padding: '2rem', display: 'flex', flexDirection: 'column', gap: '3rem', color: 'var(--md-sys-color-on-surface)' }}>

            <section className="tool-card">
                <div className="card-header">
                    <h2>Button Showcase</h2>
                    <p>Displaying all button styles available in the current project.</p>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', marginTop: '1.5rem' }}>

                    {/* Top Nav Link */}
                    <div className="field-group">
                        <span className="field-group-label" style={{ marginBottom: '1rem' }}>Top Nav Links</span>
                        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', background: 'rgba(0,0,0,0.2)', padding: '1rem', borderRadius: '12px' }}>
                            <button className="top-nav-link">Default Link</button>
                            <button className="top-nav-link" style={{ color: 'var(--md-sys-color-primary)' }}>Hover State (Simulated)</button>
                        </div>
                    </div>

                    {/* Toggle Buttons */}
                    <div className="field-group">
                        <span className="field-group-label" style={{ marginBottom: '1rem' }}>Toggle Buttons</span>
                        <MethodToggle
                            id="showcase-method-toggle"
                            options={[
                                { label: 'Active', value: 'active' },
                                { label: 'Inactive', value: 'inactive1' },
                                { label: 'Inactive', value: 'inactive2' }
                            ]}
                            selectedValue="active"
                            onChange={() => { }}
                        />
                    </div>

                    {/* Action Buttons */}
                    <div className="field-group">
                        <span className="field-group-label" style={{ marginBottom: '1rem' }}>Action Buttons</span>
                        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                            <button className="accent-button">Accent Button</button>
                            <button className="ghost-button">Ghost Button</button>
                        </div>
                    </div>

                    {/* Small Utility Buttons */}
                    <div className="field-group">
                        <span className="field-group-label" style={{ marginBottom: '1rem' }}>Small Utility Buttons</span>
                        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                            <button className="ghost-button expand-button">Expand Button</button>
                        </div>
                    </div>

                    {/* Insight Toggle */}
                    <div className="field-group">
                        <span className="field-group-label" style={{ marginBottom: '1rem' }}>Insight Card Toggle</span>
                        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                            <button className="insight-card-toggle">Toggle View</button>
                        </div>
                    </div>

                </div>
            </section>

            <section className="tool-card">
                <div className="card-header">
                    <h2 style={{ color: 'var(--md-sys-color-error)' }}>Cleanup Instructions</h2>
                    <p>To remove this showcase page completely, delete the following items:</p>
                </div>

                <div className="result-card" style={{ marginTop: '1rem' }}>
                    <ul className="result-list">
                        <li className="layer-result-item" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                            <span className="result-title">1. Delete the component file</span>
                            <code style={{ background: 'rgba(0,0,0,0.3)', padding: '0.5rem', borderRadius: '4px', fontFamily: 'monospace' }}>
                                src/components/Showcase.js
                            </code>
                        </li>
                        <li className="layer-result-item" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                            <span className="result-title">2. Update App.js</span>
                            <div className="result-summary">
                                Remove the import line:
                                <br />
                                <code style={{ background: 'rgba(0,0,0,0.3)', padding: '0.2rem', borderRadius: '4px', fontFamily: 'monospace' }}>
                                    import Showcase from './components/Showcase';
                                </code>
                                <br /><br />
                                Remove the navigation link:
                                <br />
                                <code style={{ background: 'rgba(0,0,0,0.3)', padding: '0.2rem', borderRadius: '4px', fontFamily: 'monospace' }}>
                                    {`<button className="top-nav-link" onClick={() => setActiveTab('showcase')}>Styles</button>`}
                                </code>
                                <br /><br />
                                Remove the conditional rendering block:
                                <br />
                                <pre style={{ background: 'rgba(0,0,0,0.3)', padding: '0.5rem', borderRadius: '4px', fontFamily: 'monospace', overflowX: 'auto', whiteSpace: 'pre-wrap' }}>
                                    {`{/* View 4: Showcase */}
<div className={\`spatial-view \${activeTab === 'showcase' ? 'active' : 'inactive'}\`}>
  <SafeMount component={Showcase} name="Showcase" />
</div>`}
                                </pre>
                            </div>
                        </li>
                    </ul>
                </div>
            </section>

        </div>
    );
};

export default Showcase;
